import React, { useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faUser, faHome } from '@fortawesome/free-solid-svg-icons';

/** images */
import logoutImg from '../../assets/images/logout.svg';

const AccountDropdown = ({
  handleDashboardClick,
  handleProfileClick,
  handleLogout,
  handleCloseDropdown,
}) => {
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    const userInfoEl = document.getElementsByClassName('user-info')[0];
    const targetEl = event.target;
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(targetEl) &&
      !userInfoEl.contains(targetEl)
    ) {
      handleCloseDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });

  return (
    <div className="menu-dropdown" ref={dropdownRef}>
      <div className="menu-item d-flex" onClick={handleDashboardClick}>
        <FontAwesomeIcon color="#462d7a" icon={faHome} />
        <span>Dashboard</span>
      </div>
      <div className="menu-item d-flex" onClick={handleProfileClick}>
        <FontAwesomeIcon color="#462d7a" icon={faUser} />
        <span>Profile</span>
      </div>
      <div className="menu-item d-flex" onClick={handleLogout}>
        <img src={logoutImg} alt="" />
        <span>Log out</span>
      </div>
    </div>
  );
};

export default AccountDropdown;
